import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CrudService, MessageService, Page, Search } from 'elbuild-ui-lib-core';
import { Role, UserToRole } from 'src/app/@core/model/role.model';

@Component({
	selector: 'app-user-roles',
	templateUrl: './user-roles.component.html',
	styleUrls: ['./user-roles.component.scss']
})
export class UserRolesComponent implements OnInit {

	@Input() userid;
	@Input() admin = false;

	search = new Search('usertorole');
	loading: false;
	userRoles: UserToRole[] = [];
	roles: Role[];
	constructor(private usertoroleService: CrudService<UserToRole>,
		private roleService: CrudService<Role>,
		private messageService: MessageService,
		private translateService: TranslateService
	) { }

	ngOnInit() {
		this.loadRoles();
		this.loadUserRoles();
	}

	loadUserRoles() {
		this.search.addSimpleFilter('uid', this.userid);




		this.usertoroleService.searchEntities(UserToRole, 'usertorole', this.search, new Page(100)).subscribe(result => {
			this.userRoles = result;
		}, error => {
			console.log('error', error);
		});
	}

	loadRoles() {

		const search = new Search('role');
		search.addSimpleBooleanFilter('editable', this.admin);
		this.roleService.searchEntities(Role, 'role', search, new Page(100)).subscribe(result => {
			this.roles = result;
		}, error => {
			console.log('error', error);
		});
	}

	hasRole(role: Role) {

		return this.userRoles.map(e => e.rid).includes(role.id);
	}

	addremoveRole(value, role) {
		if (value) {
			const userRole = {
				rid: role.id,
				uid: this.userid
			};
			this.usertoroleService.createEntity(UserToRole, 'usertorole', userRole).subscribe(result => {
				this.userRoles.push(result);
				this.messageService.sendSuccess(this.translateService.instant('labels.success-role-added'), this.translateService.instant('labels.role'));
			}, error => {
				this.messageService.sendError(error);
			});
		} else {
			const usertorole = this.userRoles.filter(e => e.rid === role.id)[0];
			this.usertoroleService.deleteEntity(UserToRole, 'usertorole', usertorole).subscribe(result => {
				this.userRoles = this.userRoles.filter(e => e !== usertorole);
				this.messageService.sendSuccess(this.translateService.instant('labels.success-role-removed'), this.translateService.instant('labels.role'));
			}, error => {
				this.messageService.sendError(error);
			});
		}
	}

}
